export const GetStopInRoute = ({ stopInvoiceId, routes, routeId, type }) => {
  const route = routes.find((r) => r.id === routeId);
  if (!route) return null;
  const data = route?.stops?.find((s) => s.invoiceId === stopInvoiceId);
  if (!data) return null;
  const sameType = data?.type === type;
  return sameType ? data : null;
};
